import { m } from 'framer-motion';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Badge, { badgeClasses } from '@mui/material/Badge';

import { varHover } from 'src/components/animate';
import { useSettingsContext } from 'src/components/settings';

import SvgColor from '../../components/svg-color/svg-color';

// ----------------------------------------------------------------------

export default function SettingsModeButton ({ sx }) {
  const settings = useSettingsContext();
  const theme = useTheme();
  return (
    <Badge
      color="error"
      variant="dot"
      invisible
      sx={{
        [`& .${badgeClasses.badge}`]: {
          top: 8,
          right: 8,
        },
        ...sx,
      }}
    >
      <Box
        component={m.div}
        // animate={{
        //   rotate: [0, settings.open ? 0 : 360],
        // }}
        transition={{
          duration: 12,
          ease: 'linear',
          repeat: Infinity,
        }}
      >
        <IconButton
          component={m.button}
          whileTap="tap"
          whileHover="hover"
          variants={varHover(1.05)}
          aria-label="settings"
          onClick={() => settings.onUpdate('themeMode', theme.palette.mode === 'dark' ? "light" : "dark")}
          sx={{
            width: 40,
            height: 40,
          }}
        >
          {/* <Iconify icon="solar:settings-bold-duotone" width={24} /> */}
          <SvgColor src={`/assets/icons/setting/ic_${theme.palette.mode === "light" ? "sun" : 'moon'}.svg`} />

        </IconButton>
      </Box>
    </Badge>
  );
}

SettingsModeButton.propTypes = {
  sx: PropTypes.object,
};
